/* ==========================================================================
   COFFEELIBRIUM — Theme JS
   Handles: Cart drawer, Add to Cart, Header scroll behavior
   ========================================================================== */

(function () {
  'use strict';

  // -------------------------------------------------------------------------
  // Header: Add .scrolled class on scroll
  // -------------------------------------------------------------------------
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // -------------------------------------------------------------------------
  // Cart State
  // -------------------------------------------------------------------------
  let cartData = { items: [], item_count: 0, total_price: 0 };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // -------------------------------------------------------------------------
  // Cart Drawer — Open / Close
  // -------------------------------------------------------------------------
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartTrigger = document.getElementById('cart-trigger');
  const cartClose   = document.getElementById('cart-close');
  const cartShopLink = document.getElementById('cart-shop-link');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  if (cartShopLink) {
    cartShopLink.addEventListener('click', (e) => {
      closeCart();
    });
  }

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // -------------------------------------------------------------------------
  // Render Cart UI
  // -------------------------------------------------------------------------
  function renderCart(cart) {
    cartData = cart;
    const countEl   = document.getElementById('cart-count');
    const emptyEl   = document.getElementById('cart-empty');
    const itemsEl   = document.getElementById('cart-items');
    const footerEl  = document.getElementById('cart-footer');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('visible', cart.item_count > 0);
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      if (emptyEl)  emptyEl.style.display = '';
      if (footerEl) footerEl.style.display = 'none';
      itemsEl.innerHTML = '';
      return;
    }

    if (emptyEl)  emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}" data-variant-id="${item.variant_id}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__info">
          <p class="cart-item__name">${item.product_title}</p>
          <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-item__qty">
            <button class="qty-dec" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button class="qty-inc" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>
      </div>
    `).join('');

    // Qty buttons
    itemsEl.querySelectorAll('.qty-dec, .qty-inc').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, Math.max(0, qty));
      });
    });
  }

  // -------------------------------------------------------------------------
  // Fetch current cart
  // -------------------------------------------------------------------------
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(r => r.json())
      .then(cart => { renderCart(cart); return cart; });
  }

  // -------------------------------------------------------------------------
  // Add to Cart
  // -------------------------------------------------------------------------
  function addToCart(variantId, quantity = 1, buttonEl) {
    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.textContent = 'Adding…';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    })
      .then(r => r.json())
      .then(() => fetchCart())
      .then(() => {
        openCart();
        if (buttonEl) {
          buttonEl.textContent = 'Added!';
          setTimeout(() => {
            buttonEl.disabled = false;
            buttonEl.textContent = 'Add to Cart';
          }, 1500);
        }
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (buttonEl) {
          buttonEl.disabled = false;
          buttonEl.textContent = 'Add to Cart';
        }
      });
  }

  // -------------------------------------------------------------------------
  // Update Cart Item Quantity
  // -------------------------------------------------------------------------
  function updateCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => renderCart(cart));
  }

  // -------------------------------------------------------------------------
  // Bind Add to Cart buttons (delegated)
  // -------------------------------------------------------------------------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (variantId) addToCart(variantId, 1, btn);
  });

  // -------------------------------------------------------------------------
  // Init: fetch cart on page load
  // -------------------------------------------------------------------------
  fetchCart();

  // -------------------------------------------------------------------------
  // Smooth scroll for anchor links
  // -------------------------------------------------------------------------
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        closeCart();
        const offset = header ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // -------------------------------------------------------------------------
  // Intersection Observer — fade-in sections on scroll
  // -------------------------------------------------------------------------
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.process__step, .product-card, .values__card').forEach(el => {
    el.classList.add('fade-observe');
    observer.observe(el);
  });

  // Add CSS for fade-in
  const style = document.createElement('style');
  style.textContent = `
    .fade-observe {
      opacity: 0;
      transform: translateY(18px);
      transition: opacity 0.6s ease, transform 0.6s ease;
    }
    .fade-observe.in-view {
      opacity: 1;
      transform: translateY(0);
    }
    .product-card:nth-child(2).fade-observe { transition-delay: 0.08s; }
    .product-card:nth-child(3).fade-observe { transition-delay: 0.16s; }
    .product-card:nth-child(4).fade-observe { transition-delay: 0.24s; }
    .product-card:nth-child(5).fade-observe { transition-delay: 0.32s; }
    .values__card:nth-child(2).fade-observe { transition-delay: 0.08s; }
    .values__card:nth-child(3).fade-observe { transition-delay: 0.16s; }
    .values__card:nth-child(4).fade-observe { transition-delay: 0.24s; }
    .process__step:nth-child(2).fade-observe { transition-delay: 0.1s; }
    .process__step:nth-child(3).fade-observe { transition-delay: 0.2s; }
    .process__step:nth-child(4).fade-observe { transition-delay: 0.3s; }
  `;
  document.head.appendChild(style);

  // -------------------------------------------------------------------------
// Mobile Menu Toggle
// -------------------------------------------------------------------------
const mobileMenuTrigger = document.getElementById('mobile-menu-trigger');
const mobileMenu = document.getElementById('mobile-menu');

if (mobileMenuTrigger && mobileMenu) {
  mobileMenuTrigger.addEventListener('click', () => {
    mobileMenuTrigger.classList.toggle('active');
    mobileMenu.classList.toggle('open');
  });

  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenuTrigger.classList.remove('active');
      mobileMenu.classList.remove('open');
    });
  });
}


})();

// -------------------------------------------------------------------------
// Product page: thumbnail switcher
// -------------------------------------------------------------------------
document.querySelectorAll('.product-page__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const mainImg = document.querySelector('.product-page__main-img');
    if (mainImg) mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});


